import { render, staticRenderFns } from "./page-start-view.vue?vue&type=template&id=9e4afe5c&scoped=true&"
import script from "./page-start-view.vue?vue&type=script&lang=js&"
export * from "./page-start-view.vue?vue&type=script&lang=js&"
import style0 from "./page-start-view.vue?vue&type=style&index=0&id=9e4afe5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e4afe5c",
  null
  
)

component.options.__file = "page-start-view.vue"
export default component.exports